import { getTrendingFarcasterPosts } from "@/lib/api/discover"
import { DataSource } from "./base"
import { DataSourcePagination } from "../types"
import { TrendingEntry } from "@/types/farcaster"

/**
 * Creates the Trending Farcaster data source.
 *
 * Fetches all "trending" posts on Farcaster. We
 * have some heuristics on the backend to classify these posts as Trending.
 */
export default class TrendingFarcasterDataSource implements DataSource {
  async fetchMore(props?: DataSourcePagination) {
    const data = await getTrendingFarcasterPosts(props?.page || 1, undefined)

    const pagination = this.updatePagination({
      currentPagination: props,
      newData: data,
    })

    return { data, pagination }
  }

  getInitialPagination() {
    return { page: 1 }
  }

  updatePagination(props?: {
    currentPagination?: DataSourcePagination
    newData: TrendingEntry[]
  }) {
    const oldPage = props?.currentPagination?.page || 1
    return { page: oldPage + 1 }
  }
}
